export default __webpack_public_path__ + "static/media/a016-5.2b7074b6.jpg";